import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { FuseNavigationModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';

import { NavbarVerticalStyle1Component } from 'app/layout/components/navbar/vertical/style-1/style-1.component';
import { ProfileService } from 'app/main/pages/profile/profile.service';
import { SharedModule } from 'app/shared/shared.module';

@NgModule({
  declarations: [NavbarVerticalStyle1Component],
  imports: [
    MatButtonModule,
    MatIconModule,

    FuseSharedModule,
    FuseNavigationModule,

    SharedModule,
  ],
  exports: [NavbarVerticalStyle1Component],
  providers: [ProfileService],
})
export class NavbarVerticalStyle1Module {}
